"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkOverlapping = void 0;

var checkOverlapping = function checkOverlapping(propName) {
  var foundOne = false;

  for (var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    props[_key - 1] = arguments[_key];
  }

  props.forEach(function (prop) {
    if (prop) {
      if (foundOne) {
        console.warn("[@react-css/grid] Multiple values have been provided for ".concat(propName, "."));
        return;
      }

      foundOne = true;
    }
  });
};

exports.checkOverlapping = checkOverlapping;